import CoverLoading from "./cover-loading";
export default CoverLoading;